export default __webpack_public_path__ + "static/media/rightVector.92664baa.svg";